import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  constructor(@Inject(DOCUMENT) private dom: any) {}

  setCanonicalURL(url?: string) {
    let canURL: string;
    
    if (url) {
      // If a specific URL is provided, use it as is
      canURL = url;
    } else {
      // Use environment baseUrl for SSR, fallback to location.origin for client-side
      const baseUrl = environment.baseUrl || this.dom.location.origin;
      const currentPath = this.dom.location.pathname + this.dom.location.search;
      canURL = baseUrl + currentPath;
    }
    if(!canURL.endsWith('/')){
      canURL += '/';
    }
    try {
      const existingCanonical = this.dom.head.querySelector(
        'link[rel="canonical"]'
      );
      if (existingCanonical) {
        existingCanonical.setAttribute('href', canURL);
      } else {
        const link: HTMLLinkElement = this.dom.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', canURL);
        this.dom.head.appendChild(link);
      }
    } catch (e) {
      console.error('Error setting canonical URL:', e);
    }
  }
}
